import UserList from '../features/admin/UserList';
const AdminUser= () => {
  return (
    <div>
     <UserList/>
    </div>
  )
}
export default AdminUser
